"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmDiscovery = void 0;
const AssociationsDiscovery_1 = require("./associations/AssociationsDiscovery");
const CompaniesDiscovery_1 = require("./companies/CompaniesDiscovery");
const ContactsDiscovery_1 = require("./contacts/ContactsDiscovery");
const DealsDiscovery_1 = require("./deals/DealsDiscovery");
const ExtensionsDiscovery_1 = require("./extensions/ExtensionsDiscovery");
const ImportsDiscovery_1 = require("./imports/ImportsDiscovery");
const LineItemsDiscovery_1 = require("./line_items/LineItemsDiscovery");
const ObjectsDiscovery_1 = require("./objects/ObjectsDiscovery");
const OwnersDiscovery_1 = require("./owners/OwnersDiscovery");
const PipelinesDiscovery_1 = require("./pipelines/PipelinesDiscovery");
const ProductsDiscovery_1 = require("./products/ProductsDiscovery");
const PropertiesDiscovery_1 = require("./properties/PropertiesDiscovery");
const QuotesDiscovery_1 = require("./quotes/QuotesDiscovery");
const SchemasDiscovery_1 = require("./schemas/SchemasDiscovery");
const TicketsDiscovery_1 = require("./tickets/TicketsDiscovery");
const TimelineDiscovery_1 = require("./timeline/TimelineDiscovery");
class CrmDiscovery {
    constructor(config = {}) {
        this.associations = new AssociationsDiscovery_1.AssociationsDiscovery(config);
        this.companies = new CompaniesDiscovery_1.CompaniesDiscovery(config);
        this.contacts = new ContactsDiscovery_1.ContactsDiscovery(config);
        this.deals = new DealsDiscovery_1.DealsDiscovery(config);
        this.extensions = new ExtensionsDiscovery_1.ExtensionsDiscovery(config);
        this.imports = new ImportsDiscovery_1.ImportsDiscovery(config);
        this.lineItems = new LineItemsDiscovery_1.LineItemsDiscovery(config);
        this.objects = new ObjectsDiscovery_1.ObjectsDiscovery(config);
        this.owners = new OwnersDiscovery_1.OwnersDiscovery(config);
        this.pipelines = new PipelinesDiscovery_1.PipelinesDiscovery(config);
        this.products = new ProductsDiscovery_1.ProductsDiscovery(config);
        this.properties = new PropertiesDiscovery_1.PropertiesDiscovery(config);
        this.quotes = new QuotesDiscovery_1.QuotesDiscovery(config);
        this.schemas = new SchemasDiscovery_1.SchemasDiscovery(config);
        this.tickets = new TicketsDiscovery_1.TicketsDiscovery(config);
        this.timeline = new TimelineDiscovery_1.TimelineDiscovery(config);
    }
}
exports.CrmDiscovery = CrmDiscovery;
//# sourceMappingURL=CrmDiscovery.js.map